import { createContext, type FC, type ReactNode, useContext } from 'react';
const AnalyticsContext = createContext<
  SegmentAnalytics.AnalyticsJS | undefined
>(undefined);

export const useAnalytics = (): SegmentAnalytics.AnalyticsJS => {
  const analytics = useContext(AnalyticsContext);

  if (!analytics) {
    throw new Error('useAnalytics can only be used inside AnalyticsProvider');
  }

  return analytics;
};

export const AnalyticsProvider: FC<{
  analytics?: SegmentAnalytics.AnalyticsJS;
  children?: ReactNode;
}> = ({ analytics, children }) => (
  <AnalyticsContext.Provider value={analytics}>
    {children}
  </AnalyticsContext.Provider>
);
